import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { ENVIRONMENT_TOKEN } from '../injection.tokens';
import { WebComponentOptionsService } from '@lib/core';
import { tap } from 'rxjs';
import { getFormattedCurrencyString, isNullOrEmpty } from '../function/custom-function';

@Pipe({
  name: 'money'
})
export class MoneyPipe implements PipeTransform {
  environment: any;
  showDualCurrency: boolean;
  primaryCurrencyCode: string;
  secondaryCurrencyCode: string;
  currencyConversionRate: number;
  showCurrencyAfterValue: boolean;

  constructor(
    @Inject(LOCALE_ID) private _localeId: string,
    @Inject(ENVIRONMENT_TOKEN) private env: any,
    private webComponentOptionsService: WebComponentOptionsService
  ) {
    this.environment = env;

    this.webComponentOptionsService
      .getOptionsIfNeeded()
      .pipe(
        tap((value) => {
          if (value) {
            this.showDualCurrency = Boolean(Number(value.showDualCurrency ?? 0));
            this.primaryCurrencyCode = isNullOrEmpty(value.primaryCurrencyCode) ? this.environment.constants.currency : String(value.primaryCurrencyCode);
            this.secondaryCurrencyCode = String(value.secondaryCurrencyCode);
            this.currencyConversionRate = Number(value.currencyConversionRate ?? 1);
            this.showCurrencyAfterValue = Boolean(Number(value.showCurrencyAfterValue ?? 0));
          } else {
            this.primaryCurrencyCode = this.environment.constants.currency;
            this.showCurrencyAfterValue = true;
          }
        })
      )
      .subscribe();
  }

  transform(value: number, digitsInfo: string = '1.2-2', onlyPrimaryCurrency: boolean = false): string | null {
    if (onlyPrimaryCurrency || !this.showDualCurrency) {
      return getFormattedCurrencyString({
        value: value,
        locale: this._localeId,
        primaryCurrencyCode: this.primaryCurrencyCode || this.environment.constants.currency,
        showCurrencyAfterValue: this.showCurrencyAfterValue
      });
    }

    return getFormattedCurrencyString({
      value: value,
      locale: this._localeId,
      showDualCurrency: this.showDualCurrency,
      primaryCurrencyCode: this.primaryCurrencyCode,
      secondaryCurrencyCode: this.secondaryCurrencyCode,
      currencyConversionRate: this.currencyConversionRate,
      showCurrencyAfterValue: this.showCurrencyAfterValue
    });
  }
}
